<div class="gap-[40px] flex flex-col vh-[calc(100vh-100px)] shrink-0 justify-start items-center pl-[120px] pr-[120px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] relative font-archivo">
  <div *ngIf="isLoading" class="flex flex-col items-center justify-center w-full h-full gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215ff] font-archivo text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="gap-[24px] flex flex-col w-[100%] shrink-0 justify-start items-start self-stretch">
      <button
        type="button"
        class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-archivo text-[18px] cursor-pointer hover:bg-gray-50"
        (click)="onBack()"
      >
        Back to Location List
      </button>

      <div *ngIf="errorMessage" class="text-red-600 font-archivo text-[18px]">
        {{ errorMessage }}
      </div>

      <form
        class="w-full bg-white rounded-lg border border-gray-200 p-8 flex flex-col gap-6 location-form-fields"
        (ngSubmit)="onSubmit()"
      >
        <h1 class="font-archivo text-[28px] font-bold text-[#111215ff] m-0">
          {{ pageTitle }}
        </h1>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="location-field-label" for="location-name">
              Location Name <span class="text-danger-500">*</span>
            </label>
            <input
              id="location-name"
              type="text"
              class="location-form-input"
              [(ngModel)]="locationName"
              name="locationName"
              placeholder="Enter location name"
              required
              autocomplete="off"
            />
          </div>

          <div class="location-street-field md:col-span-2">
            <label class="location-field-label" for="location-street">
              Street Address <span class="text-danger-500">*</span>
            </label>
            <div class="location-street-input-wrap">
              <input
                id="location-street"
                type="text"
                class="location-form-input location-street-input"
                [(ngModel)]="streetAddress"
                name="streetAddress"
                placeholder="Start typing to look up address"
                required
                autocomplete="off"
                (ngModelChange)="onStreetAddressInput($event)"
                (focus)="showAddressSuggestions = true"
                (blur)="onStreetAddressBlur()"
              />
              <div
                *ngIf="showAddressSuggestions && (addressSearchLoading || addressOptions.length > 0)"
                class="location-address-suggestions"
                role="listbox"
              >
                <div *ngIf="addressSearchLoading" class="location-address-suggestion location-address-suggestion--muted">
                  Searching…
                </div>
                <button
                  *ngFor="let option of addressOptions"
                  type="button"
                  class="location-address-suggestion"
                  role="option"
                  (mousedown)="onStreetAddressSelected(option)"
                >
                  {{ option.label }}
                </button>
              </div>
            </div>
          </div>

          <div>
            <label class="location-field-label" for="location-city">
              City <span class="text-danger-500">*</span>
            </label>
            <input
              id="location-city"
              type="text"
              class="location-form-input"
              [(ngModel)]="city"
              name="city"
              placeholder="Enter city"
              required
              autocomplete="address-level2"
            />
          </div>

          <div>
            <label class="location-field-label" for="location-state">
              State <span class="text-danger-500">*</span>
            </label>
            <input
              id="location-state"
              type="text"
              class="location-form-input"
              [(ngModel)]="state"
              name="state"
              placeholder="Enter state (e.g. TX)"
              required
              maxlength="40"
              autocomplete="address-level1"
            />
          </div>

          <div>
            <label class="location-field-label" for="location-zip">
              Zip <span class="text-danger-500">*</span>
            </label>
            <input
              id="location-zip"
              type="text"
              class="location-form-input"
              [(ngModel)]="zip"
              name="zip"
              placeholder="Enter zip code"
              required
              maxlength="10"
              autocomplete="postal-code"
            />
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="location-field-label">Status</span>
          <NiFormToggle
            label="Active"
            [(ngModel)]="isActive"
            name="isActive"
          />
        </div>

        <div class="flex flex-row flex-wrap gap-4 items-center justify-end pt-4 border-t border-gray-200">
          <button
            type="button"
            class="rounded-[999px] px-[24px] py-[10px] bg-white border border-gray-300 font-archivo text-[18px] cursor-pointer hover:bg-gray-50"
            (click)="onBack()"
          >
            Cancel
          </button>

          <button
            type="submit"
            class="rounded-[999px] px-[24px] py-[10px] bg-[#F26F24] text-white font-archivo text-[18px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="isSaving"
          >
            {{ mode === 'create' ? 'Create Location' : 'Save Changes' }}
          </button>
        </div>
      </form>
    </div>
  </ng-container>
</div>
